import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';

export default class Preloader extends Component {
	constructor() {
		super({
			element: document.querySelector('.preloader'),
			elements: {
				images: document.querySelectorAll('[data-pre]'),
				number: document.querySelector('.preloader__number'),
			},
		});

		this.createTimeline();
	}

	createTimeline() {
		this.timeline = GSAP.timeline({
			paused: true,
			onComplete: () => {
				this.elements.number.innerText = '0%';
			},
		});

		this.timeline.fromTo(
			this.element,
			{ autoAlpha: 1 },
			{ autoAlpha: 0, duration: 0.82, ease: 'expo.out' }
		);
	}

	// called from Loader
	createLoader(template) {
		this.length = 0;

		if (this.elements.images.length > 0)
			this.elements.images.forEach((img) => {
				// console.log('loadImg', img);
				this.loadImage(img);
			});

		if (this.elements.images.length === 0) {
			this.animatePercentFromZeroToFull(1);
		}
		// setTimeout(this.onLoaded.bind(this), 100);
	}

	loadImage(img) {
		if (img.tagName.toLowerCase() === 'img') {
			// <img> tag
			// if (img.src) {
			// 	console.log(img, 'already loaded');
			// 	return this.onAssetLoaded(); // Image is already loaded
			// }

			const boundOnAssetLoaded = this.onAssetLoaded.bind(this);
			img.addEventListener('load', boundOnAssetLoaded);

			img.onload = function () {
				img.removeEventListener('load', boundOnAssetLoaded);
			};

			img.src = img.getAttribute('data-pre');
		} else {
			// other tags (for background image)
			const imageUrl = img.getAttribute('data-pre');
			const tempImage = new Image();

			tempImage.onload = () => {
				img.style.backgroundImage = `url(${imageUrl})`;
				this.onAssetLoaded();
				tempImage.onload = null; // optional, goes to garbage collection anyways
			};

			tempImage.src = imageUrl;
		}
	}

	// async loadImages() {
	// 	const images = Array.from(document.querySelectorAll('[data-pre]'));
	// 	const loadImage = (img) => {
	// 		return new Promise((resolve, reject) => {
	// 			img.src = img.getAttribute('data-pre');
	// 			img.onload = resolve;
	// 			img.onerror = reject;
	// 		});
	// 	};
	// 	await Promise.all(images.map(loadImage));
	// }
	animatePercentFromZeroToFull(value) {
		this.elements.number.innerText = '0%';
		// from 0 to 0.99
		GSAP.to(this.elements.number, {
			innerText: Math.round(value * 100),
			duration: 0.3,
			ease: 'power1.out',
			onUpdate: () => {
				this.elements.number.innerText = `${Math.round(
					this.elements.number.innerText
				)}%`;
			},
			onComplete: () => {
				this.onLoaded();
			},
		});
	}

	onAssetLoaded() {
		this.length++;
		let imageLength = 0;

		if (this.elements.images) {
			imageLength += this.elements.images.length;
		}

		const percent = this.length / imageLength;
		this.elements.number.innerText = `${Math.round(percent * 100)}%`;
		console.log(percent);

		if (percent === 1) {
			setTimeout(this.onLoaded.bind(this), 1000);
		}
	}

	onLoaded() {
		this.$emit('onPreloaded');
		// this.emit('completed');
	}

	show() {
		return new Promise((resolve) => {
			this.timeline.reverse().then(() => {
				resolve();
			});
		});
	}

	hide() {
		this.timeline.play();

		// .then(this.destroy.bind(this));
	}

	destroy() {
		// this.element.parentNode.removeChild(this.element);
	}
}
